import {useEffect, useState} from "react";
import { handlePlayPause, handleVideoElementSizeInfo } from "redux-share/actions";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { conditions, isTouchScreen, videoTag } from "helpers";
import { ConditionName, zIndex } from "interfaces";
import { setShowScreen } from "redux-share/slices/videoDataSlice";
import useActiveInActive from "helpers/hooks/useActiveInActive";
import useFullScreen from "helpers/hooks/useFullScreen";
import PlayerCore from "ui/src/components/player-core/playerCore";
import { shallowEqual } from 'react-redux'
import Image from "next/image";
import dynamic from "next/dynamic";

const TouchVolumeBrightness = dynamic(() => import("ui/src/components/player-components/touchVolumeBrightness/touchVolumeBrightness"));
const BackwardForward = dynamic(() => import("ui/src/components/player-components/backwardForward/backwardForward"));
const Advertisement = dynamic(() => import("ui/src/components/player-components/ad/advertisement"));
const Header = dynamic(() => import("ui/src/components/mainComponent/header/header"));
const Footer = dynamic(() => import("ui/src/components/mainComponent/footer/footer"));
const Main = dynamic(() => import("ui/src/components/mainComponent/main/main"));

const Player = () => {

    const [isRightDoubleTouched, setIsRightDoubleTouched] = useState<boolean>(false);
    const [isLeftDoubleTouched, setIsLeftDoubleTouched] = useState<boolean>(false);
    const { params } = useAppSelector(({ videoData: { params, isAdBlockerActivate, ads, recommendationList } }) => ({ params, isAdBlockerActivate, ads, recommendationList }), shallowEqual);
    const { firstPlay, showMiniPlayer, isFullScreen } = useAppSelector(({ controller: { firstPlay, showMiniPlayer, isFullScreen, activeElements, canPlayVideo, isEnded } }) => ({ firstPlay, showMiniPlayer, isFullScreen, activeElements, canPlayVideo, isEnded }), shallowEqual);
    useAppSelector(({ popovers: { autoPlayPopover } }) => ({ autoPlayPopover }), shallowEqual);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (videoTag()) {
            let timeout:any;
            const handleResize = () => {
                if (!conditions(ConditionName.showMiniPlayer)) {
                    timeout = setTimeout(() => {
                        handleVideoElementSizeInfo();
                        dispatch(setShowScreen(true));
                    }, conditions(ConditionName.isTouchScreen) ? 0 : 300)
                }
            }
            handleResize();
            window.addEventListener("resize", handleResize);

            return () => {
                window.removeEventListener("resize", handleResize);
                clearTimeout(timeout);
            }
        }
    }, [firstPlay, showMiniPlayer, isFullScreen, videoTag()])

    // --- Managing the active and inActive of elements in desktop and mobile devices --- //
    useActiveInActive(isRightDoubleTouched, isLeftDoubleTouched);

    useFullScreen();

    return (
        <div className="pl-h-screen pl-flex pl-justify-center pl-items-center pl-overflow-hidden">
            <div
                className={`pl-relative pl-w-full pl-h-full pl-bg-black pl-max-h-screen pl-aspect-video pl-flex pl-items-center ${!conditions(ConditionName.isActiveElements) && "pl-cursor-none"}`}
                onClick={(event) => conditions(ConditionName.showBannerStaticFiles) && !conditions(ConditionName.isAdBlockerActivate) ? handlePlayPause(event) : () => {}}
                id="video-area"
            >
                {conditions(ConditionName.showBannerStaticFiles) && <div className='pl-absolute pl-w-full pl-h-full pl-flex pl-justify-center'>
                    <Image src={params.cover!} layout='fill'  alt="sdfdf" objectFit="contain"/>
                </div>}
                {conditions(ConditionName.showTouchVolumeBrightness) && <TouchVolumeBrightness />}
                {conditions(ConditionName.showBackwardForward) && !conditions(ConditionName.isPlayingAd) && (
                    <div
                        className={`pl-absolute pl-top-0 pl-right-0 pl-w-full pl-h-full pl-overflow-hidden pl-flex pl-items-center`}
                        style={{zIndex: (isLeftDoubleTouched || isRightDoubleTouched) ? zIndex.backwardForwardActive : zIndex.backwardForwardInActive}}>
                        <BackwardForward type="touchForward" isRightDoubleTouched={isRightDoubleTouched} setIsRightDoubleTouched={setIsRightDoubleTouched} />
                        <BackwardForward type="touchBackward" isLeftDoubleTouched={isLeftDoubleTouched} setIsLeftDoubleTouched={setIsLeftDoubleTouched} />
                    </div>
                )}
                {conditions(ConditionName.isPlayingAd) && !conditions(ConditionName.isFirstPlay) && <Advertisement />}
                {conditions(ConditionName.isAdBlockerActivate) && (
                    <div onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }} onDoubleClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                        className={`${isTouchScreen() ? "pl-text-[13px]" : "pl-text-[16px]"} pl-text-center pl-top-0 pl-left-0 pl-absolute pl-h-full pl-w-full pl-bg-secondary-700/[0.8] pl-backdrop-blur-[4px] pl-flex pl-items-center pl-justify-center pl-p-2 pl-z-[10000000] pl-text-white`}>
                        کاربر گرامی، برای مشاهده ویدیو، لطفا افزونه عدم نمایش تبلیغات را غیرفعال نمایید.
                    </div>
                )}
                <div className={`${conditions(ConditionName.isPlayingAd) && "pl-absolute pl-w-full pl-h-full"}`}><PlayerCore /></div>
                {(conditions(ConditionName.canPlayVideo) || conditions(ConditionName.isIOS)) && (
                    <div id="playerElements"
                        className={`pl-absolute pl-top-0 pl-right-0 pl-w-full pl-h-full ${conditions(ConditionName.showAutoPlayPopover) && "pl-bg-black"}`}>
                        <div className={`pl-flex pl-flex-col pl-justify-between pl-w-full pl-h-full`}>
                            {!conditions(ConditionName.isPlayingAd) && conditions(ConditionName.showHeader) && <Header /> }
                            {((conditions(ConditionName.isPlayingAd) && conditions(ConditionName.isFirstPlay)) || !conditions(ConditionName.isPlayingAd)) && <Main /> }
                            {!conditions(ConditionName.isPlayingAd) && !conditions(ConditionName.isFirstPlay) && <Footer /> }
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Player;